export const Partners = {
  Snaphire: 1,
  JobAdder: 2,
  JazzHR: 4,
  Teamtailor: 5,
  Onboarded: 6,
  Bullhorn: 7,
  Lever: 8,
  UKG: 9,
  AccountApi: 10,
  SmartRecruiters: 12,
  Workato: 13,
  KnowMy: 14,
  PageUp: 15,
  BambooHR: 16,
  Livehire: 17,
  TCC_SAP: 18,
  Avature: 19,
};

export const PartnersHuman = {
  0: '-',
  1: 'Snaphire',
  2: 'Job Adder',
  4: 'JazzHR',
  5: 'TeamTailor',
  6: 'Onboarded',
  7: 'Bullhorn',
  8: 'Lever',
  9: 'UKG',
  10: 'Account',
  11: 'BackyCheck',
  12: 'SmartRecruiters',
  13: 'Workato',
  14: 'KnowMy',
  15: 'PageUp',
  16: 'BambooHR',
  17: 'Livehire',
  18: 'TCC_SAP',
  19: 'Avature',
};

export const PartnersCodes = {
  AccountApi: 'account_api',
  TAS: 'tas',
  JobAdder: 'job_adder',
  JazzHR: 'jazzhr',
  Teamtailor: 'teamtailor',
  Bullhorn: 'bullhorn',
  Onboarded: 'onboarded',
  Lever: 'lever',
  UKG: 'ukg',
  KnowMy: 'knowmy',
  BambooHR: 'bambooHR',
  PageUp: 'pageup',
  Livehire: 'livehire',
  SmartRecruiters: 'smartrecruiters',
  Workato: 'workato',
  KnowMy: 'knowmy',
  PageUp: 'pageup',
  BambooHR: 'bambooHR',
  Livehire: 'livehire',
  TCC_SAP: 'tcc_sap',
  Avature: 'avature',
};

export const PartnersEnum = {
  1: PartnersCodes.TAS,
  2: PartnersCodes.JobAdder,
  4: PartnersCodes.JazzHR,
  5: PartnersCodes.Teamtailor,
  6: PartnersCodes.Onboarded,
  7: PartnersCodes.Bullhorn,
  8: PartnersCodes.Lever,
  9: PartnersCodes.UKG,
  10: PartnersCodes.AccountApi,
  11: PartnersCodes.PageUp,
  12: PartnersCodes.SmartRecruiters,
  13: PartnersCodes.Workato,
  14: PartnersCodes.KnowMy,
  15: PartnersCodes.PageUp,
  16: PartnersCodes.BambooHR,
  17: PartnersCodes.Livehire,
  18: PartnersCodes.TCC_SAP,
  19: PartnersCodes.Avature,
};
